/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_setCacheHas.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_setCacheHas.js
// module chunks = 1